/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Videos_DescriptionInputs */

const en_settings_overview_videos_description = /** @type {(inputs: Settings_Overview_Videos_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rap videos rendered so far`)
};

/**
* | output |
* | --- |
* | "Rap videos rendered so far" |
*
* @param {Settings_Overview_Videos_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_overview_videos_description = /** @type {((inputs?: Settings_Overview_Videos_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Videos_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_overview_videos_description(inputs)
});
export { settings_overview_videos_description as "settings.overview.videos_description" }